import React from 'react';
import Group from './script/Group';

const ScriptOptions = ({scripts, items, parameters, extraFields}) => (
    <>
        {scripts.map((script, index) => (
            <div key={index} className="row align-items-center alert alert-warning">
                <div className="col-10">
                    <Group expressions={script.expression} items={items} parameters={parameters} extraFields={extraFields} />
                </div>
                <div className="col-2 text-right">
                    <span className="page-id badge badge-primary">{script.id}</span>
                </div>
            </div>
        ))}
    </>
);

export default ScriptOptions;
